import { useMutation } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

/**
 * Bulk export for a batch of orders.
 * Variables: ids string[]
 * Enqueues an export job — does not mutate order state, so no cache invalidation.
 */
export function useBulkExport() {
  return useMutation({
    mutationFn: async (ids: string[]) => {
      const { data, error } = await apiClient.POST("/v1/orders/bulk-export", {
        body: { ids },
      });
      if (error) throw error;
      return data;
    },
  });
}
